<template>
  <button
    type="button"
    class="btn btn-sm btn-outline-primary btn-block"
    :disabled="desabilitado"
    @click="solicitarManual"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm mr-1"
      role="status"
      aria-hidden="true"
    ></span>
    Solicitar Lote
  </button>
</template>

<script>
import {
  SNCR_CATEGORIAS,
  SNCR_LIMITE_MAXIMO_DIARIO,
  SNCR_LIMITE_MAXIMO_MENSAL,
} from "./sncr.const";

export default {
  name: 'SNCRSolicitarLoteButton',

  props: {
    tipo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    categorias() {
      return SNCR_CATEGORIAS;
    },
    disponivel() {
      return this.tipo.lote ? this.tipo.lote.in_total_nums_lote : 0;
    },
    atingiuLimite() {
      if (this.tipo.categoria === this.categorias.DIARIO) {
        return this.disponivel >= SNCR_LIMITE_MAXIMO_DIARIO;
      }
      if (this.tipo.categoria === this.categorias.MENSAL) {
        return this.disponivel >= SNCR_LIMITE_MAXIMO_MENSAL;
      }
      return false;
    },
    desabilitado() {
      return this.loading || this.atingiuLimite;
    },
    ehDiario() {
      return this.tipo.categoria === this.categorias.DIARIO;
    },
    ehMensal() {
      return this.tipo.categoria === this.categorias.MENSAL;
    },
  },

  methods: {
    solicitarManual() {
      this.$emit('iniciar-solicitacao');
      this.solicitar();
    },

    solicitar() {
      if (this.desabilitado) return;

      if (this.ehDiario) {
        this.solicitarReceita();
        return;
      }
      if (this.ehMensal) {
        this.solicitarReceitaEspecial();
      }
    },

    dadosMedico() {
      const userAuth = this.$store.state.user;
      return {
        conselho: userAuth.medico.conselho.st_sigla,
        uf: userAuth.medico.estado_conselho.st_sigla,
        documento: userAuth.medico.in_numero_conselho,
        id_medico: userAuth.id_pessoa,
      };
    },

    mensagemErro(error) {
      return (error && error.data && error.data.mensagem) || 'Falha ao solicitar lote';
    },

    tratarErro(error) {
      if (error && error.status === 401) {
        this.$emit('nao-autorizado', this.tipo);
        return;
      }
      this.$toast.add({
        severity: "warn",
        summary: "Falha ao solicitar lote",
        detail: this.mensagemErro(error),
        life: 4000,
      });
    },

    solicitarReceita() {
      const medico = this.dadosMedico();
      this.loading = true;
      this.$util.atualizar(this, {
        service: 'sncr',
        func: 'solicitar_receita',
        dados: {
          receita: this.tipo.sigla,
          conselho: medico.conselho,
          uf: medico.uf,
          documento: String(medico.documento),
          quantidade: 10,
          id_medico: medico.id_medico,
        },
        callback: () => {
          this.$emit('sucesso');
        },
        callback_error: error => {
          this.tratarErro(error);
        },
        final: () => {
          this.loading = false;
        },
      });
    },

    solicitarReceitaEspecial() {
      const medico = this.dadosMedico();
      this.loading = true;
      this.$util.atualizar(this, {
        service: 'sncr',
        func: 'solicitar_receita_especial',
        dados: {
          conselho: medico.conselho,
          tipo: this.tipo.sigla,
          documento: String(medico.documento),
          uf: medico.uf,
          id_medico: medico.id_medico,
        },
        callback: () => {
          this.$emit('sucesso');
        },
        callback_error: error => {
          this.tratarErro(error);
        },
        final: () => {
          this.loading = false;
        },
      });
    },
  },
};
</script>
